import dayjs from 'dayjs'

export const getRemainingTimeUntilMsTimestamp = (withHours: boolean, targetTime: any) => {
  const now = dayjs()
  const target = dayjs(targetTime)

  if (target.isBefore(now)) {
    return withHours ? { seconds: null, minutes: null, hours: null } : { seconds: null, minutes: null }
  }

  const seconds = getRemainingSeconds(now, target)
  const minutes = getRemainingMinutes(now, target)
  const hours = withHours ? getRemainingHours(now, target) : undefined

  return withHours ? { seconds, minutes, hours } : { seconds, minutes }
}

export const getNextMidnight = () => {
  return dayjs().add(1, 'day').startOf('day')
}

const getRemainingSeconds = (now: any, target: any) => {
  const seconds = target.diff(now, 'seconds') % 60
  return padWithZeros(seconds, 2)
}

const getRemainingMinutes = (now: any, target: any) => {
  const minutes = target.diff(now, 'minutes') % 60
  return padWithZeros(minutes, 2)
}

const getRemainingHours = (now: any, target: any) => {
  const hours = target.diff(now, 'hours') % 24
  return padWithZeros(hours, 2)
}

const padWithZeros = (number: number, length: number) => {
  return number.toString().padStart(length, '0')
}
